import ErrorState from "./errorState";
import {ErrorStateActions, errorStateActions} from "./errorState.types";

export {errorStateActions};
export type {ErrorStateActions};

export default ErrorState;
